import classNames from 'classnames';
import styles from './FJImageManipulationColorizer.module.less';
import PropTypes from 'prop-types';
import FJSwitchButton from '../../../../common/components/FJSwitchButton/FJSwitchButton';
import { COLORIZER_COLOR_LIST } from '../../../../constants/FJImageManipulationConstant';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJConfig from '../../../../config/FJConfig';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';

const FJImageManipulationColorizer = props => {
    const { active, text, onChange, className, style, disabled, selectedColorName, onColorizerChange } = props;

    return (
        <div className={classNames(styles.card, className, disabled && styles.disabled)} style={style}>
            <div className={styles.header}>
                <div className={styles.text}>{text}</div>
                <FJSwitchButton active={active} onChange={onChange} />
            </div>

            <div className={classNames(styles.color_box, active && styles.active_color_box)}>
                <div className={styles.color_list_box}>
                    {COLORIZER_COLOR_LIST.map(item => (
                        <FJHoverBoardGradation
                            key={item.name}
                            className={styles.color_item}
                            text={item.name}
                            value={item.value}
                            isShowInBorder={true}
                            onClick={() => onColorizerChange(item.name)}
                            active={selectedColorName === item.name}
                        >
                            <img
                                src={FJConfig.colorizerImageUrl + item.name + '.png'}
                                alt={item.name}
                                className={styles.color_item_image}
                            />
                            <FJTextWithEllipsisParent
                                className={styles.color_item_name}
                                text={FJLocalStore._(item.name)}
                            ></FJTextWithEllipsisParent>
                        </FJHoverBoardGradation>
                    ))}
                </div>
            </div>
        </div>
    );
};

FJImageManipulationColorizer.propTypes = {
    active: PropTypes.bool,
    text: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    selectedColorName: PropTypes.string,
    onColorizerChange: PropTypes.func,
};

export default FJImageManipulationColorizer;
